import { Box } from "@mui/material"
import { palette } from "../../../assets/theme/theme"
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CustomParagraph } from "../../../components/CustomMiscellaneous/CustomParagraph";
import HorizontalRule from "../../../components/HorizontalRule/HorizontalRule";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { ButtonRow } from "../../../components/ButtonRow";
import { ConfirmationModal } from "../Modals/ConfirmationModal";
import { useState } from "react";
import CopyModal from "../Modals/CopyModal";
import { EntityConfig, PropConfig } from "../../../types/EntityConfig";
import { CardStyle } from "../../../styles/card";


type EntityDisplayInput = {
  form: any,
  allowCopy?: boolean,
  generatePdf: ((id: any) => Promise<any> )| null,
  tableConfigs: EntityConfig,
  submitData: Function,
  deleteData: Function,
  setEditable: Function,
  idProp: string,
  entityName: string,
  data: any,
  blockEdit?: boolean
}



export default function EntityDisplay({ form,
  allowCopy,
  generatePdf,
  tableConfigs,
  submitData,
  deleteData,
  setEditable,
  idProp,
  data,
  entityName,
  blockEdit } : EntityDisplayInput) {

  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);


  const getButtons = () => {
    const arr = [];

    if(!blockEdit) {
      arr.push({ text: "Editar", color: palette.blue.light, onClick: () => setEditable(true), icon: EditIcon });
    }

    if (allowCopy)
      arr.push({ text: "Criar Cópia", color: palette.orange, onClick: () => setFormModalOpen(true), icon: ContentCopyIcon });

    if (generatePdf)
      arr.push({ text: "Gerar PDF", color: palette.purple, onClick: () => { console.log("Will generate pdf"); generatePdf(form.state.id) }, icon: PictureAsPdfIcon });

    arr.push({ text: "Eliminar", color: palette.red, onClick: () => setConfirmationModalOpen(true), icon: DeleteForeverIcon });
    return arr;
  }



  return (
    <>
      <ConfirmationModal isOpen={confirmationModalOpen} text={"Eliminar a entidade?"} onConfirm={deleteData} onCancel={() => setConfirmationModalOpen(false)} />
      <CopyModal
        isOpen={formModalOpen}
        tableConfigs={tableConfigs.filter((tc : any) => tc.existsOnCopyForm)}
        modalData={form.state}
        editable={true}
        setIsOpen={setFormModalOpen}
        postEntity={()=>{submitData();setFormModalOpen(false)}}
        form={form}
        onRequestClose={() => setFormModalOpen(false)}
         />

      <Box style={{...CardStyle, marginBottom: 30}}>
        <div style={{ }}>
          <h1>{`${entityName}`} {data[idProp] ? `${data?.id}` : ''}</h1>

        </div>

        <div style={{ paddingTop: 20 }}>
          {tableConfigs.filter((tc : any )=> !tc.hidden)
            .map((tc : PropConfig, i: number) => {
            return (<div key={`${data[tc.id]}-${i}`}><CustomParagraph
              key={i}
              prop={tc.label}
              type={tc.type}
              displayInfo={tc.displayInfo}
              routable={tc.routable}
              entityName={entityName}
              idProp={idProp}
              options={tc.options}
              displayFunction={tc.displayFunction}
              data={data[tc.id]}
              tableConfigs={tableConfigs}
            />

              {i < tableConfigs.length - 1 ? <HorizontalRule style={{border: `1px solid ${palette.gray.medium}`}}/> : null}
            </div>)
          })}
        </div>

        <div style={{ width: '100%', left: 0, bottom: 0, justifyContent: 'end', display: 'flex' }}>
          <ButtonRow
            buttons={getButtons()}
          />
        </div>


      </Box>

    </>
  )


}